import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export var APPSTORE_ID = 1497334859;
export var APPSTORE_URL = "https://apps.apple.com/us/app/outdoor-voices/id".concat(APPSTORE_ID);
export var APP_BANNER_PATH_BLACKLIST = ['/checkout'];
export var BREAK_MOBILE = 480;
export var BREAK_MOBILE_MEDIUM = 666;
export var BREAK_TABLET_SMALL = 890;
export var BREAK_TWO_COLUMN = 960;
export var CONTACT_EMAIL = 'hello@outdoorvoices.com';
export var CONTACT_PHONE_FORMATTED = '(512) 960-3144';
export var CONTACT_PHONE_NUMBERS = '5129603144';
export var DT = 'Doing Things';
export var KEY_CODE_ESC = 27;
export var OV_ALERT = 'OV:alert';
export var OV_SIZE_GUIDE = 'OV:sizeGuide';
export var OV_SUBSCRIBE = 'OV:subscribe';
export var NAV_HEIGHT = 72;
export var RESIZE = 'resize';
export var SCROLL = 'scroll';
export var COOKIES = {
  CAPTURE: {
    DISMISSED: 'ov-capture-dismiss',
    SEEN: 'ov-capture-seen'
  },
  DOER_FLAG_CLOSED: 'doer-flag-closed',
  DOER_HANDLE: 'doer-handle',
  IP_COUNTRY: 'ip-country',
  OVU_CREATE: 'ovu-account-create',
  PROMO: 'ov-promo-code',
  PT_SHOWN: 'ov-pt-shown',
  SUBSCRIBED: 'ov-subscribed',
  TOP_BANNER_DISMISSED: 'ov-tbd'
};
var Accept = 'application/json, text/plain, */*';
export var FORM_POST_HEADERS = {
  headers: {
    Accept: Accept,
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  },
  method: 'POST'
};
export var JSON_HEADERS = {
  headers: {
    Accept: Accept,
    'Content-Type': 'application/json'
  }
};
export var POST_HEADERS = _objectSpread(_objectSpread({}, JSON_HEADERS), {}, {
  method: 'POST'
});
export var SUBTITLES = "".concat(process.env.OV_CDN, "video/silent-video.vtt");
export var TEXT = {
  addToBag: 'Add to Bag',
  alert: {
    message: "We cannot load this page right now.  We're looking into it, so check back shortly.",
    title: 'Something went wrong.'
  },
  alertCX: {
    message: "\n      Oh no. We&apos;re looking into the issue, but please reach out to\n      <a href=\"mailto:".concat(CONTACT_EMAIL, "\">").concat(CONTACT_EMAIL, "</a> to get help sooner."),
    title: 'Something went wrong.'
  },
  emailCapture: {
    title: 'Join The Team',
    text: 'Sign up for exclusive OV-only deals and early access to new products.',
    errors: {
      birthday: 'Please enter a valid birthdate.',
      submit: 'There was an issue signing up. Please try again later.',
      email: 'Please enter a valid email.'
    },
    success: {
      title: 'Sweet!',
      text: "We'll be in touch soon."
    },
    tip: 'By signing up you agree to receive promotional emails from Outdoor Voices'
  },
  inventory: {
    almostGone: 'Almost Gone',
    // 1-5 remaining
    comingSoon: 'Coming Soon',
    fewLeft: 'Only a few left',
    // 6-10 remaining
    jtwl: 'Join The Waitlist',
    soldOut: 'Sold Out' // 0 remaining

  },
  scrollDown: 'Click to scroll down to page content'
};
export var LOW_INVENTORY_QUANTITY = 10;
export var MAX_IN_CART = 10;
export var WAITLIST_TYPES = {
  WAITLIST: TEXT.inventory.jtwl,
  COMING_SOON: TEXT.inventory.comingSoon,
  NONE: ''
};
export var MISSING_IMG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export var PAGE_TITLE = ' – Outdoor Voices — Technical Apparel for Recreation';
export var FINAL_SALE = 'Final Sale';
export var SOLD_OUT = 'Sold Out'; // Shipping + Returns

export var SHIPPING_THRESHOLD = 75;
export var SHIPPING_SPEED_FAST = '2 Day';
export var SHIPPING_LOCATION_US = 'in the U.S.';
export var FREE_SHIPPING = "Free Shipping on orders over $".concat(SHIPPING_THRESHOLD);
export var FREE_SHIPPING_SHORT = "Free Shipping over $".concat(SHIPPING_THRESHOLD);
export var SHIPPING_HED_CA = 'Standard Shipping now available to Canada';
export var SHIPPING_HED_US = "".concat(FREE_SHIPPING, " ").concat(SHIPPING_LOCATION_US);
export var BANNER_HEIGHT = 36;
export var BREADCRUMBS_HEIGHT = 58; // A default value for visitor id

export var VISITOR_ID = 'GA1.2.1100523453.1576244974';
export var TED_PID = 'UHJvZHVjdE5vZGU6NzY5';